import { Flex } from "@chakra-ui/react";
import SelectableButton from "components/Button/SelectableButton";
import { TipoAutorizacaoPortariaEnum } from "features/portaria/enums";
import { getColor } from "./CardPortaria/index";

const SelectableTag = ({
  value,
  tipo,
  text,
  onChange,
  onUnselect,
}: {
  value: TipoAutorizacaoPortariaEnum | null;
  tipo: TipoAutorizacaoPortariaEnum;
  text: string;
  onChange: (v: TipoAutorizacaoPortariaEnum | null) => void;
  onUnselect: () => any;
}) => (
  <SelectableButton
    selected={value === tipo}
    onClick={() => {
      onChange(tipo);
    }}
    onUnselect={onUnselect}
    rounded="full"
    selectedColor={getColor(tipo)}
    fontSize="14px"
  >
    {text}
  </SelectableButton>
);

function TableTags({
  value,
  onChange,
}: {
  value: TipoAutorizacaoPortariaEnum | null;
  onChange: (v: TipoAutorizacaoPortariaEnum | null) => void;
}) {
  const onUnselect = () => onChange(null);

  return (
    <Flex flex={1} gridGap="12px" flexWrap="wrap">
      <SelectableTag
        tipo={TipoAutorizacaoPortariaEnum.Visitante}
        text="Visitante"
        onUnselect={onUnselect}
        onChange={onChange}
        value={value}
      />

      <SelectableTag
        tipo={TipoAutorizacaoPortariaEnum.Delivery}
        text="Delivery"
        onUnselect={onUnselect}
        onChange={onChange}
        value={value}
      />

      <SelectableTag
        tipo={TipoAutorizacaoPortariaEnum.Encomenda}
        text="Encomenda"
        onUnselect={onUnselect}
        onChange={onChange}
        value={value}
      />

      <SelectableTag
        tipo={TipoAutorizacaoPortariaEnum.FuncionarioDomestico}
        text="Funcionário Doméstico"
        onUnselect={onUnselect}
        onChange={onChange}
        value={value}
      />

      <SelectableTag
        tipo={TipoAutorizacaoPortariaEnum.PrestadorServico}
        text="Prestadores de Serviço"
        onUnselect={onUnselect}
        onChange={onChange}
        value={value}
      />

      <SelectableTag
        tipo={TipoAutorizacaoPortariaEnum.Transporte}
        text="Transporte"
        onUnselect={onUnselect}
        onChange={onChange}
        value={value}
      />

      <SelectableTag
        tipo={TipoAutorizacaoPortariaEnum.ListaConvidados}
        text="Lista de Convidados"
        onUnselect={onUnselect}
        onChange={onChange}
        value={value}
      />
    </Flex>
  );
}

export default TableTags;
